type BoardTypeAction = {
  type: "BOARD_TYPE";
  payload: string;
};

type BoardTypeState = string;

// Changed default from "DEFAULT" to "AUTOMATION" - all boards are now automation boards
const boardType = (state: BoardTypeState = "AUTOMATION", action: BoardTypeAction): BoardTypeState => {
  switch (action.type) {
    case "BOARD_TYPE": {
      return action.payload;
    }
    default:
      return state;
  }
};

export default boardType;
